// A SUB-STEP'S FILED NAME, its step's printed number and then its own, counting from 1: "3-2".
// What a prompt says, what the model answers with, and the key a published clip is filed under.
// `n` is SubStep.letter, which holds the number (see _sub_step_number).
export const subStepLabel = (step: number | string | null | undefined, n: string | null | undefined) =>
  `${step ?? ''}-${n ?? ''}`;

// AND THE NAMES A READER SEES, for a manual's sub-steps in its own order.
//
// THE PUBLISHED PAGE'S NUMBERS: one screen per sub-step it was sent, counted in its step — 1-1,
// 1-2, … Publishing leaves out a sub-step nobody signed off, so a screen's number there can be
// lower than the sub-step's filed one. In the app every sub-step is shown under its filed name.
//
// It counted no number for a sub-step with no movement to show — a tightening — and named it after
// the one before with a letter ("1-3b"). There are none any more: since 2026-10-17 a tool goes
// with the gesture it is used in (see subStepKinds), and nothing is joined to anything after.
//
// Its own module, importing nothing: the public page names its screens with it, and that page is
// not the app.
export function shownSubStepNames(subs: { step: number | string | null | undefined }[]): string[] {
  const counted = new Map<string, number>();
  return subs.map(({ step }) => {
    const at = String(step ?? '');
    const n = (counted.get(at) ?? 0) + 1;
    counted.set(at, n);
    return subStepLabel(step, String(n));
  });
}
